import { render, staticRenderFns } from "./MlbbPlayerTable.vue?vue&type=template&id=072a47e0"
import script from "./MlbbPlayerTable.vue?vue&type=script&lang=js"
export * from "./MlbbPlayerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports